<template>
    <div>
        <tr-text v-for="(p, idx) in labels" :key="idx"
            v-bind="p"
            :tracker="tracker"
            @edit-tr="$emit('edit-tr', $event)"
        ></tr-text>
    </div>
</template>

<script>
import TrText from "@/components/translation/TrText"

export default {
    name:     "I18nGetsum",
    components: {TrText},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    },
    computed : {
        labels () {
            const result = []
            for (const l of this.props.label.val) {
                if (typeof l !== "string")
                     result.push ({t9n: true,  val: [l]})
                else result.push ({t9n: false, val: l})
            }
            return result
        }
    }
}
</script>

<style>
</style>